import { render, staticRenderFns } from "./CellRendererVerified.vue?vue&type=template&id=2b8fa393"
import script from "./CellRendererVerified.vue?vue&type=script&lang=js"
export * from "./CellRendererVerified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports